import { clearAuthSession } from "./auth0";

// Everything the app persists for a signed-in session. `logoutUser` and the out-of-tree
// `endSession` below both clear this same list so the two paths cannot drift.
const SESSION_KEYS = [
  "user",
  "activeKey",
  "tenantsData",
  "usersData",
  "selectedTenantName",
  "currentTenant",
  "currentEnv",
  // filter values
  "tenantsSearchTerm",
  "usersSearchTerm",
  "usersSelectedTenant"
];

// Survives the reload in `endSession` so the login screen can say why it is asking again.
export const LOGIN_MESSAGE_KEY = "loginMessage";

export const clearSession = () => {
  clearAuthSession();
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

let ending = false;

/**
 * End the session from outside the React tree — the Apollo error link and the
 * environment switch in App, neither of which can reach `logoutUser` from the context.
 * Reloading onto the login route is what re-initialises the context from the now-empty
 * localStorage. Guarded so several failing queries cannot each trigger a reload.
 */
export const endSession = (message) => {
  if (ending) {
    return;
  }
  ending = true;

  clearSession();

  if (message) {
    window.sessionStorage?.setItem(LOGIN_MESSAGE_KEY, message);
  }

  window.location.replace("/");
};

// Reading and clearing are separate so the login page can read it from a render without
// a side effect, which StrictMode would run twice and swallow the message.
export const peekLoginMessage = () => window.sessionStorage?.getItem(LOGIN_MESSAGE_KEY) || "";

export const clearLoginMessage = () => {
  window.sessionStorage?.removeItem(LOGIN_MESSAGE_KEY);
};
